import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { NewsletterItemState, NewsletterItemStateModel } from './newsletter-item.state';
import {
  NewsletterItemInitialState,
  NewsletterItemLoad,
  NewsletterItemSave,
  NewsletterItemSend,
  NewsletterTypesLoad,
} from './newsletter-item.actions';
import { NewsletterItem } from '..';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';
import { NewsletterType } from '../models/newsletter-type.model';

@Injectable({ providedIn: 'root' })
export class NewsletterItemFacade implements LoadDataFacade, SetInitialStateFacade {
  newsletterItemData$: Observable<NewsletterItemStateModel> = this.store.select(NewsletterItemState.getState);
  newsletterItemId$: Observable<number> = this.store.select(NewsletterItemState.getNewsletterItemId);
  newsletterTypes$: Observable<NewsletterType[]> = this.store.select(NewsletterItemState.getNewsletterTypes);
  loaded$: Observable<boolean> = this.store.select(NewsletterItemState.getLoaded);

  constructor(private store: Store) {}

  loadAll(dpnItemId: number): void {
    this.store.dispatch(new NewsletterItemLoad(dpnItemId));
  }

  saveNewsletterItem(data: Partial<NewsletterItem>): void {
    this.store.dispatch(new NewsletterItemSave(data));
  }

  sendNewsletterItem(newsletterItemId: number, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new NewsletterItemSend({ newsletterItemId, dialog }));
  }

  loadNewsletterTypes(): void {
    this.store.dispatch(new NewsletterTypesLoad());
  }

  setInitialState(): void {
    this.store.dispatch(new NewsletterItemInitialState());
  }
}
